module.exports = __webpack_public_path__ + "static/media/aboutBg.4e8ab6f4.png";